import React, { useState } from 'react';
import { ActivityIndicator } from 'react-native';
import { translate } from '../services/translate';
import { NavigationProp, useNavigation, useNavigationState } from '@react-navigation/native';
import UserInformationModal from '../components/UserInformationModal';
import { RootStackParamList } from '../typings/Params';
import { useStyles } from 'react-native-unistyles';
import { useAuth } from '../context/Auth';
import { useForm } from 'react-hook-form';
import FormInput from '../components/FormInput';
import CustomButton from '../components/CustomButton';
import Toast from 'react-native-toast-message';
import { centralAPI } from '../services/central-api';
import Container from '../components/Container';
import Header from '../components/Header';
import Card from '../components/Card';

interface TicketForm {
    subject: string;
    comment: string;
}

export default function ContactUs() {
    const { theme } = useStyles();
    const { user: authenticatedUser } = useAuth();
    const index = useNavigationState(state => state);
    const [showDropDown, setShowDropDown] = useState<boolean>(false);

    const navigation = useNavigation<NavigationProp<RootStackParamList>>();

    function goBack() {
        if (index.routes.length > 1) {
            return navigation.goBack();
        }
        navigation.navigate('Menu');
    }

    const defaultEmptyValues: TicketForm = {
        subject: '',
        comment: ''
    };

    const form = useForm<TicketForm>({
        defaultValues: defaultEmptyValues,
        mode: 'onChange'
    });
    const { formState: { isValid } } = form;

    if (!authenticatedUser) {
        return (
            <Container style={{ justifyContent: 'center', alignItems: 'center' }}>
                <ActivityIndicator size='large' color={theme.colors.iconColor} />
            </Container>
        );
    }

    async function formSubmit() {
        try {
            const isValid = await form.trigger();

            if (!isValid) {
                throw new Error('invalid form');
            }

            const values = form.getValues();
            await centralAPI.createOwnSupportTicket(values);

            Toast.show({
                type: 'sentinelxSuccess',
                text1: translate('ActionSuccessfully'),
            });

            form.reset();
        } catch (err) {
            console.error(err);
            Toast.show({
                type: 'sentinelxError',
                text1: translate('unexpectedError'),
            });
        }
    }

    return (
        <Container>
            <Header title={translate('contactUs')} goBackAction={goBack} actions={
                <CustomButton
                    onPress={() => formSubmit()}
                    text={translate('send')}
                    disabled={!isValid}
                />}
            />
            <Card scrollView={true}>
                <FormInput
                    label={translate('subject')}
                    form={form}
                    fieldName='subject'
                    required={true}
                />
                <FormInput
                    label={translate('comment')}
                    form={form}
                    fieldName='comment'
                    required={true}
                    multiline={true}
                    numberOfLines={10}
                />
            </Card>
            <UserInformationModal
                showDropDown={showDropDown}
                setShowDropDown={setShowDropDown}
                navigation={navigation}
            />
        </Container>
    );
}
